<template>
    <div>
            <h2>Relatório de Solicitação de Orçamento</h2>
            <div class="d-flex w-100">
                <!-- <form class="w-100 flex-grow-1 d-flex mt-5 mb-5">
                    <v-row>
                        <v-col cols="5" sm="6" md="5">
                            <v-text-field
                                v-model="filter.dataInicio"
                                type="date"
                                chips
                                clearable
                                hide-details
                                hide-selected
                                label="Search"
                                solo
                                @input="getRelatorioSalesOrder"
                            />
                        </v-col>
                        <v-col cols="5" sm="6" md="5">
                            <v-text-field
                                v-model="filter.dataFim"
                                type="date"
                                chips
                                clearable
                                hide-details
                                hide-selected
                                label="Search"
                                solo
                                @input="getRelatorioSalesOrder"
                            />
                        </v-col>
                        
                        <v-col cols="2" sm="2" md="1">

                            <v-menu
                                :close-on-content-click="false"
                                location="end"
                            >
                                <template v-slot:activator="{ on }">
                                    <v-btn v-on="on" large icon color="primary">
                                        <v-icon>mdi-filter</v-icon>
                                    </v-btn>
                                </template>

                                <v-card min-width="500">

                                    <v-card-title>
                                        Filtro
                                    </v-card-title>

                                    <v-card-text>

                                        <v-text-field
                                            chips clearable 
                                            hide-details
                                            hide-selected 
                                            label="Orçamento" 
                                            solo 
                                            v-model="filter.codigo"
                                        >
                                        </v-text-field>

                                        <v-text-field
                                            chips clearable 
                                            hide-details
                                            hide-selected 
                                            label="Cliente" 
                                            class="mt-5 mb-5"
                                            solo 
                                            v-model="filter.cliente"
                                        >
                                        </v-text-field>

                                        <v-text-field
                                            chips clearable 
                                            hide-details
                                            hide-selected 
                                            label="Vendedor" 
                                            class="mt-5 mb-5"
                                            solo 
                                            v-model="filter.vendedor"
                                        >
                                        </v-text-field>

                                        <v-text-field
                                            chips 
                                            clearable 
                                            hide-details
                                            hide-selected 
                                            label="Orçamentista" 
                                            class="mt-5 mb-5"
                                            solo 
                                            v-model="filter.orcamentista"
                                        >
                                        </v-text-field>

                                    </v-card-text>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>

                                        <v-btn variant="text">
                                            Cancel
                                        </v-btn>
                                        <v-btn color="primary" variant="text" @click="getRelatorioSalesOrder">
                                            Filtrar
                                        </v-btn>
                                    </v-card-actions>
                                </v-card>

                            </v-menu>
                        </v-col>

                    </v-row>

                </form> -->
                
                <div class="text-center mt-5 mb-5">
                    <v-menu>
                        <template v-slot:activator="{ on }">
                            <v-btn
                                color="primary"
                                v-on="on" 
                                large
                            >
                                Gerar Relatorio
                            </v-btn>
                        </template>

                        <v-list>
                            <v-list-item
                                v-for="(item, index) in actions"
                                :key="index"
                                :value="index"
                                @click="item.handle"
                                class="cursor-pointer"
                            >
                                <v-list-item-title>{{ item.title }}</v-list-item-title>
                            </v-list-item>
                        </v-list>

                    </v-menu>

                    <v-btn class="ml-5" @click="openModalFilter = true" large color="primary" outlined>
                        Filtro
                        <v-icon>mdi-filter</v-icon>
                    </v-btn>

                </div>

            </div>

            <v-simple-table dense class="w-100 pdf-content">
                <thead>
                    <tr>
                        <th>Orçamento</th>
                        <th>Cliente</th>
                        <th>Projeto</th>
                        <th>Contato</th>
                        <th>Fone</th>
                        <th>Data/Soli</th>
                        <th>Orçamentista</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="dado in dadosTabela" :key="dado._id" style="cursor: pointer;">
                        <template v-if="!dado.revisoes">
                            <td>
                                {{ dado.codigo }}
                            </td>
                            <td>
                                {{ dado.clienteNome || "Cliente Não Informado" }}
                            </td>
                            <td>
                                -
                            </td>
                            <td>
                                {{  dado.contatoComercialNome }}
                            </td>

                            <td>
                                {{  dado.contatoComercialTelefone }}
                            </td>
                            <td>
                                {{ new Date(dado.dateGenerate).toLocaleDateString() }}
                            </td>
                            <td>
                                {{ dado.orcamentistaNome }}
                            </td>

                        </template>

                        <template v-else>
                            <td>
                                {{ dado.revisoes.codigo }}
                            </td>
                            <td>
                                {{ dado.revisoes.clienteNome || "Cliente Não Informado" }}
                            </td>
                            <td>
                                -
                            </td>
                            <td>
                                {{  dado.revisoes.contatoComercialNome }}
                            </td>

                            <td>
                                {{  dado.revisoes.contatoComercialTelefone }}
                            </td>
                            <td>
                                {{ new Date(dado.revisoes.dateGenerate).toLocaleDateString() }}
                            </td>
                            <td>
                                {{ dado.revisoes.orcamentistaNome }}
                            </td>
                        </template>

                    </tr>
                </tbody>
            </v-simple-table>

            <RelatorioSalesOrderPreview
                :isOpen="openPreview"
                :dadosTabela="dadosTabela"
                @cancel="openPreview = false"
            />

            <RelatorioResumoComercial 
                :isOpen="openResumoComercial"
                :salesOrderData="dadosTabela"
                @cancel="openResumoComercial = false"
            />

            <ModalFilterSalesOrder 
                :open="openModalFilter"
                @filter-applied="aplicateFilter"
                @close="openModalFilter = false"
            />
            
    </div>
</template>

<script>
import Vue from 'vue'
import moment from 'moment';
import html2pdf from 'html2pdf.js'
import * as XLSX from 'xlsx'
import RelatorioSalesOrderPreview from './RelatorioSalesOrderPreview.vue';
import RelatorioResumoComercial from './RelatorioResumoComercial.vue';
import ModalFilterSalesOrder from './ModalFiterSalesOrder'

export default {
  components: { RelatorioSalesOrderPreview, RelatorioResumoComercial, ModalFilterSalesOrder },
    name: 'RelatorioSalesOrderView',
    data() {
        return {
            filter: {
                dataInicio: '',
                dataFim: '',
                codigo: '',
                cliente: '',
                vendedor: '',
                orcamentista: ''
            },
            dadosTabela: [],
            actions: [
                { title: 'Exportar PDF', 
                    handle: () => {
                        this.openPreview = true
                    }
                },
                { title: 'Exportar Excel', handle: this.exportExcel },
                // { 
                //     title: 'Resumo Comercial', handle: () => {
                //         this.openResumoComercial = true
                //     }
                // }
            ],
            openPreview: false,
            openResumoComercial: false,
            openModalFilter: false
        };
    },

    methods: {

        async getRelatorioSalesOrder() {
            const response = await Vue.prototype.$http.post('/View/run', {
                    params: [
                        { dataType: "String", name: "dataInicio", value: this.filter.dataInicio ? moment(this.filter.dataInicio).format('YYYY-MM-DD') : moment('1970-01-01').format('YYYY-MM-DD') },
                        { dataType: "String", name: "dataFim", value: this.filter.dataFim ? moment(this.filter.dataFim).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD') },
                        { dataType: "string", name: "codigo", value: this.filter.codigo },
                        { dataType: "string", name: "cliente", value: this.filter.cliente },
                        { dataType: "string", name: "vendedor", value: this.filter.vendedor },
                        { dataType: "string", name: "orcamentista", value: this.filter.orcamentista },
                        { dataType: "string", name: "order", value: "clienteNome" },
                        { dataType: "Number", name: "desc", value: this.filter.order ? Number(this.filter.order) : 1 }
                    ],
                    viewName: "get-relatorio-sales-order",
                    page: 1,
                    limit: 3000000

            })
            this.dadosTabela = response.data.data.data
        },

        aplicateFilter(newFilter) {
            this.filter = { ...newFilter }
            this.getRelatorioSalesOrder()
            this.openModalFilter = false
        },

        exportPdf(){

            const elemento = document.getElementById("conteudoPDF");
            html2pdf()
            .set({
                margin: 10,
                filename: 'Relatorio-Solicitação-Orçamento.pdf',
                html2canvas: { scale: 2 },
                jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
            })
            .from(elemento)
            .save()
        },

        exportExcel() {
            const dataRelatorio = this.dadosTabela.map((item) => {
                // Se tiver revisões, usa ela, senão usa o item principal
                const dados = item.revisoes ? item.revisoes : item;

                return {
                    'Orçamento': dados.codigo || '',
                    'Cliente': dados.clienteNome || "Cliente Não Informado",
                    'Projeto': '-', // você fixou como "-" na tabela
                    'Contato': dados.contatoComercialNome || '',
                    'Fone': dados.contatoComercialTelefone || '',
                    'Data/Soli': dados.dateGenerate 
                        ? new Date(dados.dateGenerate).toLocaleDateString('pt-BR') 
                        : '',
                    'Orçamentista': dados.orcamentistaNome || ''
                }
            });

            const ws = XLSX.utils.json_to_sheet(dataRelatorio);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'Relatório JOB');

            XLSX.writeFile(wb, 'Solicitação-Orçamento.xlsx');
        }
    },

    created() {
        this.getRelatorioSalesOrder()
    }
}
</script>

<style scoped>


.pdf-content {
  font-family: 'Arial', sans-serif;
}

/* @media print {
  #conteudoPDF {
    display: block !important;
  }
} */
</style>